import React from "react";
import { ArticleCard, ArticleListItem } from "./ArticleCard";
import { SectionHead } from "./SectionParts";
import { TrendingUp } from "lucide-react";

export default function TrendingGrid({ articles = [] }) {
  const items = articles.slice(0, 7);
  if (!items.length) return null;
  const [first, ...rest] = items;
  const sidebar = rest.slice(0, 4);
  const grid = rest.slice(4);

  return (
    <section className="my-16" data-testid="trending-section">
      <SectionHead title="ट्रेंडिंग खबरें" subtitle="आज सबसे ज्यादा पढी जा रही" icon={<TrendingUp className="h-4 w-4" />} />
      <div className="grid lg:grid-cols-12 gap-6">
        <div className="lg:col-span-7">
          <ArticleCard a={first} size="lg" />
          {grid.length > 0 && (
            <div className="mt-4 grid sm:grid-cols-2 gap-4">
              {grid.map((a) => (
                <ArticleCard key={a.id} a={a} size="md" />
              ))}
            </div>
          )}
        </div>
        <aside className="lg:col-span-5 bg-gradient-to-br from-zinc-50 to-white border border-zinc-100 rounded-2xl p-6">
          <div className="flex items-center gap-2 mb-5">
            <span className="font-outfit font-black uppercase tracking-widest text-xs bodh-text-gradient">Top Picks</span>
            <span className="flex-1 bodh-divider" />
          </div>
          <div className="space-y-5">
            {sidebar.map((a, i) => (
              <ArticleListItem key={a.id} a={a} index={i} />
            ))}
          </div>
        </aside>
      </div>
    </section>
  );
}
